export default {
  root: {},
  elevation1: {
    boxShadow: '0 0.25rem 1.25rem 0 rgba(153, 155, 168, 0.35)'
  }
};
